
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import Dienstort from '@/types/Dienstort';
    import { DataTableHeaders, DataTableHeaderType } from '@/types';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';
    import DienstorteDetail from '@/components/Dienstorte/DienstorteDetail.vue';

    @Component({
        components: {
            DienstorteDetail,
        },
        computed: {
            ...mapState('dienstorte', ['dienstorte', 'dialogs', 'loaders']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('dienstorte', ['loadDienstorte']),
            ...mapMutations('dienstorte', ['setDialogsDetail']),
        },
    })
    export default class Dienstorte extends Vue {
        public dienstort = new Dienstort();
        public search = '';

        public loadDienstorte!: () => void;
        public setDialogsDetail!: (visible: boolean) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;

        public get headers(): DataTableHeaders<Dienstort> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Dienstort', value: 'dienstort' },
                { text: 'Dienstort Langtext', value: 'dienstort_langtext' },
                { text: 'Parent Dienstort', value: 'parent_dienstort_id_dienstort' },
            ].filter((header) => header) as DataTableHeaders<Dienstort>;
        }

        public mounted(): void {
            this.loadDienstorte();
        }

        public onClickEdit(dienstort: Dienstort): void {
            this.dienstort = new Dienstort(dienstort);
            this.setDialogsDetail(true);
        }

        public onClickNew(): void {
            this.dienstort = new Dienstort();
            this.setDialogsDetail(true);
        }
    }
